import $ from 'jquery';

$(function () {
  $('.hamburger').on('click', function () {
    $('body').toggleClass('menu-active');
    $(this).toggleClass('is-active');
  });
});

$(document).ready(function() {
  $('.subnav .current-item, .subnav__icon').click(function(e) {
    $('.subnav nav').toggleClass('expanded');
  });
});
